export default __webpack_public_path__ + "static/media/youtube_logo.284bd724.svg";